import { render } from "./HaircolorTreat.vue?vue&type=template&id=4d088b6a"
import script from "./HaircolorTreat.vue?vue&type=script&lang=js"
export * from "./HaircolorTreat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__